import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";
import { toastAlert } from "../AlertComponent";

import EditCategoryBody from "./category/EditCategoryBody";
import EditCategoryList from "./category/EditCategoryList";

const EditCategory = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	// const history = useHistory();
	// const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	// const setChannel = (value) => dispatch(setReduxChannel(value));
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [selectCategory, setSelectCategory] = useState(0);
	const [categoryList, setCategoryList] = useState({
		ingredientList: [],
		functionList: [],
		combinationList: [],
	});
	const [selectKey, setSelectKey] = useState({});
	const [linkList, setLinkList] = useState([]);
	const [productList, setProductList] = useState([]);

	useEffect(() => {
		getCategory();
	}, []);

	/**
	 * ingredientList, functionList 가져오기
	 * @param type
	 * @returns {Promise<void>}
	 */
	const getCategory = async (type, target) => {
		if (type !== "order") {
			setIsLoading(true);
			let param = {
				influencerId:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
			};

			const res = await partnersApi.readCategoryList(param);
			const rsq = await partnersApi.readCombinationList(param);

			if (res.code === 200 && rsq.code === 200) {
				let result = {
					ingredientList: res.result?.totalIngredientList,
					functionList: res.result?.functionList,
					combinationList: rsq.result,
				};
				setCategoryList(result);
				if (type === "save") {
					toastAlert("성공적으로 저장되었습니다!");
					window.scrollTo({
						// top: search.offsetTop - (5 * 16),
						top: 0,
						behavior: "smooth",
					});
					if (selectKey?.ingredient_id) {
						const newSelectKey = result?.ingredientList?.filter(
							(item) => item.id === selectKey.id
						)?.[0];
						if (newSelectKey?.id === selectKey.id) {
							setSelectKey(newSelectKey);
							// setProductList([]);
						}
					} else if (selectKey?.category_name) {
						const newSelectKey = result?.combinationList?.filter(
							(item) => item.id === selectKey.id
						)?.[0];
						if (newSelectKey?.id === selectKey.id) {
							setSelectKey(newSelectKey);
							// setProductList([]);
						}
					}
					// addNewCombination();
				} else if (type === "edit") {
					toastAlert("성공적으로 적용되었습니다!");
					window.scrollTo({
						// top: search.offsetTop - (5 * 16),
						top: 0,
						behavior: "smooth",
					});
					if (selectKey?.ingredient_id) {
						const newSelectKey = result?.ingredientList?.filter(
							(item) => item.id === selectKey.id
						)?.[0];
						if (newSelectKey?.id === selectKey.id) {
							setSelectKey(newSelectKey);
							// setProductList([]);
						}
					} else if (selectKey?.category_name) {
						const newSelectKey = result?.combinationList?.filter(
							(item) => item.id === selectKey.id
						)?.[0];
						if (newSelectKey?.id === selectKey.id) {
							setSelectKey(newSelectKey);
							// setProductList([]);
						}
					}
					// console.log(result);
					// addNewCombination();
				} else if (type === "delete") {
					toastAlert("성공적으로 삭제되었습니다!");
					window.scrollTo({
						// top: search.offsetTop - (5 * 16),
						top: 0,
						behavior: "smooth",
					});
					// addNewCombination();
				}
			}
			setIsLoading(false);
		}
	};

	return (
		<div className={`channel-edit-component`}>
			<div className={`channel-edit-category-wrap`}>
				{/* 카테고리 리스트 */}
				<EditCategoryList
					selectCategory={selectCategory}
					setSelectCategory={setSelectCategory}
					categoryList={categoryList}
					setCategoryList={setCategoryList}
					selectKey={selectKey}
					setSelectKey={setSelectKey}
					setLinkList={setLinkList}
					setProductList={setProductList}
					getCategory={getCategory}
				/>

				{/* 카테고리 내용 */}
				<EditCategoryBody
					selectCategory={selectCategory}
					categoryList={categoryList}
					selectKey={selectKey}
					setSelectKey={setSelectKey}
					linkList={linkList}
					setLinkList={setLinkList}
					productList={productList}
					setProductList={setProductList}
					getCategory={getCategory}
				/>
			</div>
		</div>
	);
};

export default EditCategory;
